var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/theming/~/core-js/internals/classof-raw.js
// module id = 216
// module chunks = 168707334958949